<template>
  <div class="wrapper">
    <div class="animated fadeIn" v-if="ready">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        {{ this.$route.meta.label }}
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card>
            <h2>Descargar stock con formato de subida</h2>
            <p>
              Descargue el stock en formato excel para actualizar las cantidades. El archivo descargado incluye
              instrucciones para actualizar el stock. Siga al pie de la letra las instrucciones.
            </p>
            <b-form-group label="Exportadora/Cliente">
              <b-form-select v-model="client" :options="clientOptions" required></b-form-select>
            </b-form-group>
            <b-form-group label="Bodega">
              <b-form-select
                v-model="company"
                value-field="id"
                text-field="name"
                :options="companyOptions"
                required
              ></b-form-select>
            </b-form-group>
            <b-button @click.prevent="downloadWithAxios(1, 1)" variant="primary">Descargar</b-button>
            <hr />
            <h2>Subir archivo con nuevo stock</h2>
            <p>
              <strong>Importante:</strong> respete el formato del excel descargado. De lo contrario su módulo de
              materiales podría descuadrarse de manera irrecuperable.
            </p>
            <b-form @submit="onSubmit">
              <b-form-group label="Archivo">
                <b-form-file
                  v-model="file1"
                  placeholder="Elija un archivo o arrastre acá..."
                  drop-placeholder="Arrastre acá..."
                  browse-text="Explorar"
                ></b-form-file>
                <div class="mt-3">Archivo seleccionado: {{ file1 ? file1.name : "" }}</div>
              </b-form-group>
              <b-button :disabled="loading || !Boolean(file1)" type="submit" variant="primary">Subir archivo</b-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "StockUpload",
  data() {
    return {
      ready: false,
      loading: false,
      file1: null,
      company: null,
      companyOptions: [],
      client: null,
      clientOptions: []
    };
  },
  mounted() {
    this.ready = true;
    this.getCompanies();
    this.getClients();
  },
  methods: {
    async getCompanies() {
      try {
        const response = await this.$axios({
          method: "GET",
          url: "api/v1/company/warehouses/?no_page",
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.loading = false;
        this.companyOptions = response.data;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async getClients() {
      // Get client_customer_options
      try {
        const response = await this.$axios({
          method: "GET",
          url: "production/get_customers/",
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.loading = false;
        this.clientOptions = response.data.data;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.$store.dispatch("toggleOverlay");
      this.loading = true;
      try {
        let fd = new FormData();
        fd.append("file", this.file1);
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        await this.$axios.post("/supplies/upload-stock/", fd, config);
        this.file1 = null;
        this.$swal({
          title: "Éxito",
          text: "El archivo se ha subido correctamente",
          type: "success",
          confirmButtonText: "Aceptar"
        });
      } catch (err) {
        console.log(err);
        this.$swal("Error", err.response.data.detail, "error");
      } finally {
        this.loading = false;
        this.$store.dispatch("toggleOverlay");
      }
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Stock.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: `/supplies/download-stock/?company_id=${this.company}&client_company_id=${this.client}`,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.detail, "error");
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
